'use strict';

angular.module('mean.bids').controller('BidRequestReviewController', ['$scope', 'MeanUser', 'Global', 'Bids', '$filter', '$sce', 'toaster', 'NotifyService', 'BidRequestReview', 'CompanyFactors', '$location', 'tradeCodeService', 'taskTotalsService', 'TradeBids', 'bidRequestEditService', 'TradeItems', 'userService',
  function($scope, MeanUser, Global, Bids, $filter, $sce, toaster, NotifyService, BidRequestReview, CompanyFactors, $location, tradeCodeService, taskTotalsService, TradeBids, bidRequestEditService, TradeItems, userService) {
    $scope.global = Global;

    $scope.expanded_table = 'true';
    $scope.bid_total_labor = 0;
    $scope.bid_total_materials = 0;
    $scope.bid_total_equipment = 0;
    $scope.bid_total = 0;
    $scope.bid_general_liability = 0;
    $scope.available_materials = [];
    $scope.available_categories = [];
    $scope.available_tasks = [];
    $scope.bid_menu = [];
    $scope.my_inclusions = [];
    $scope.my_exclusions = [];

    $scope.editSpecText = '';
    $scope.editSpecHeader = '';
    $scope.editSpecIndex = 0;

    $scope.materials = [];
    $scope.equipment = [];

    $scope.MaterialTotal = 0;
    $scope.EquipmentTotal = 0;

    $scope.sortType = ['task', 'name', 'note'];
    $scope.sortReverse = false;

    var data = [];

    $scope.user = MeanUser.user;

    $scope.viewDetails = function(type, index, text) {
        //this function gets called when the spec modal is active
        //and sets some global variables for the edit functions
        $scope.editSpecIndex = index;
        if(type) {
            $scope.editSpecHeader = 'Inclusion Edit';
        } else {
            $scope.editSpecHeader = 'Exclusion Edit';
        }

        $scope.editSpecText = text;
    };

    $scope.acceptEditSpec = function() {
        $scope.bid.bidding_trades.forEach(function(bidder, ii){
            if($scope.getTradeCode(bidder.trade) === $scope.my_bid_trade) {
                if($scope.editSpecHeader === 'Inclusion Edit') {
                    bidder.inclusions[$scope.editSpecIndex] = $scope.editSpecText;
                    $scope.my_inclusions = bidder.inclusions;
                } else {
                    bidder.exclusions[$scope.editSpecIndex] = $scope.editSpecText;
                    $scope.my_exclusions = bidder.exclusions;
                }

                $scope.bid.$update();
            }
        });
    };

    $scope.cancelEditSpec = function() {
        $scope.bid.bidding_trades.forEach(function(bidder, ii){
            if($scope.getTradeCode(bidder.trade) === $scope.my_bid_trade) {
                if($scope.editSpecHeader === 'Inclusion Edit') {
                    $scope.my_inclusions = bidder.inclusions;
                } else {
                    $scope.my_exclusions = bidder.exclusions;
                }
            }
        });
    };

    $scope.deleteSpec = function() {
        $scope.bid.bidding_trades.forEach(function(bidder, ii){
            if($scope.getTradeCode(bidder.trade) === $scope.my_bid_trade) {
                if($scope.editSpecHeader === 'Inclusion Edit') {
                    bidder.inclusions.splice($scope.editSpecIndex, 1);
                    $scope.my_inclusions = bidder.inclusions;
                } else {
                    bidder.exclusions.splice($scope.editSpecIndex, 1);
                    $scope.my_exclusions = bidder.exclusions;
                }
                $scope.bid.$update();
            }
        });
    };

    $scope.addInclusion = function() {
        $scope.bid.bidding_trades.forEach(function(bidder, ii){
            if($scope.getTradeCode(bidder.trade) === $scope.my_bid_trade) {
                bidder.inclusions.push($scope.newInclusion);
                $scope.my_inclusions = bidder.inclusions;
                $scope.bid.$update();
            }
        });

        $scope.newInclusion = '';
    };

    $scope.addExclusion = function() {
        $scope.bid.bidding_trades.forEach(function(bidder, ii){
            if($scope.getTradeCode(bidder.trade) === $scope.my_bid_trade) {
                bidder.exclusions.push($scope.newExclusion);
                $scope.my_exclusions = bidder.exclusions;
                $scope.bid.$update();
            }
        });
        
        $scope.newExclusion = '';
    };

    $scope.toggleTableColumns = function() {
        if($scope.expanded_table === 'true') {
            $scope.expanded_table = 'false';
        } else {
            $scope.expanded_table = 'true';
        }
    };

    $scope.init = function() {
        $scope.expanded_table = 'false';
    	$scope.bid = BidRequestReview.get();

        if(!$scope.bid || !$scope.bid._id){
            $location.path('home');
            return;
        }

        $scope.review_trade_index = $scope.bid.review_trade_index;
        var tb = $scope.bid.bidding_trades[$scope.review_trade_index];

        TradeBids.query({'_id': tb._id}, function(bids) {
            if(bids.length !== 1) {
                toaster.pop('error', 'Database', 'Could not find the bid');
                return;
            }

            $scope.bid.bidding_trades[$scope.review_trade_index] = bids[0];

        	$scope.bid_menu = [];

        	var menu = $scope.bid.project_plan;

            // $scope.bid_menu.push({
            //     item: 'Materials'
            // });

            // $scope.bid_menu.push({
            //     item: 'Equipment'
            // });

            $scope.bid_menu.push({
                item: 'Cover'
            });

            $scope.bid_menu.push({
                item: 'Specs'
            });

            _.each($scope.bid.plan_codes, function(plan_code) {
                $scope.bid_menu.push({
                    item: plan_code.code
                });
            });

            $scope.bid_menu.push({
                item: 'Total Materials'
            });

            $scope.bid_menu.push({
                item: 'Trade Rates'
            });

            $scope.current_plan = $scope.bid_menu[0];
            $scope.main_bid_menu = $scope.bid_menu;

        	var bid_tasks = [];
            var current_bid_trade = $scope.bid.bidding_trades[$scope.review_trade_index];

            $scope.my_bid_trade = $scope.getTradeCode(current_bid_trade.trade);
            $scope.my_bid = current_bid_trade;

            $scope.my_inclusions = $scope.my_bid.inclusions;
            $scope.my_exclusions = $scope.my_bid.exclusions;

            $scope.material_supplier = $scope.my_bid.supplier;

            TradeItems.query({
                'company_code': userService.getCompanyCode($scope.user.username),
                'trade_code': userService.getTradeCode($scope.user.username),
                'bid_id': $scope.bid._id }, function(tradeItems) {
                if(tradeItems.length === 0) {
                    $scope.tradeItems = {
                        hours_allowed: true,
                        crew_rate: true,
                        trade_rates: true,
                        labor_costs: true,
                        liability: true,
                        markup: true,
                        material_costs: true,
                        equipment_costs: true,
                        quantity: true
                    }
                } else if(tradeItems.length === 1) {
                    $scope.tradeItems = tradeItems[0];
                } else {
                    toaster.pop('error', 'Trade Items Error', 'Contact Admin');
                    return;
                }
            });

            $scope.bid_menu.forEach(function(menu) {
                if(menu.item === 'Total Materials' || menu.item === 'Cover' || menu.item === 'Specs' || menu.item === 'Trade Rates')
                    return;

                $scope.my_bid.task_list.forEach(function(task, index){
            		if(task.trade === $scope.my_bid_trade){
            			var bidder = $scope.my_bid;

        				if(bidder.trade === current_bid_trade.trade) {
                            //need to get bid_hours, quantities, etc... for each bid menu
                            //make sure the plan and task id's match up.
                            bidder.bid.forEach(function(bid, ii) {
                                if(bid.plan_code === menu.item) {
                                    if(bid.task_id === task._id) {
                                        
                                        bid.subtasks.forEach(function(subtask, si) {
                                            task.subtasks.forEach(function(tsub, tsi) {
                                                if(subtask.task_id === tsub._id) {
                                                    tsub.quantity = subtask.quantity;
                                                    tsub.bid_hours = subtask.bid_hours;
                                                    tsub.labor = subtask.labor;
                                                }
                                            });

                                            subtask.equipment.forEach(function(eq, eidx) {
                                                task.subtasks[si].equipment.forEach(function(teq, teidx) {
                                                    if(eq.equipment_id === teq._id) {
                                                        teq.quantity = eq.quantity;
                                                        teq.plan_code = menu.item;
                                                        if(eq.price_per_order)
                                                          teq.price_per_order = eq.price_per_order;
                                                        if(eq.delivery_price)
                                                          teq.delivery_price = eq.delivery_price;
                                                    }
                                                });
                                            });

                                            subtask.materials.forEach(function(mq, midx) {
                                                task.subtasks[si].materials.forEach(function(tmq, tmidx) {
                                                    if(mq.material_id === tmq._id) {
                                                        tmq.quantity = mq.quantity;
                                                        tmq.plan_code = menu.item;
                                                        if(mq.price_per_order)
                                                          tmq.price_per_order = mq.price_per_order;
                                                        if(mq.delivery_price)
                                                          tmq.delivery_price = mq.delivery_price;
                                                    }
                                                });
                                            });
                                        });
                                    }

                                    bid_tasks.push(angular.copy(task));
                                }
                            });
        				}
            		}
            	});
            });
            
            $scope.company_factors = $scope.my_bid.costs;

            $scope.applayCalculations(bid_tasks);
            
            $scope.materials = 
                    bidRequestEditService.getMaterials($scope.my_bid.bid, $scope.my_bid.task_list);

            $scope.onSelect($scope.current_plan);
        });
    };

    $scope.rejectBid = function() {
        console.log('in the rejectBid function' + $scope);
        $scope.bid.bidding_trades[$scope.review_trade_index].submitted = 'false';
        TradeBids.query({'_id': $scope.bid.bidding_trades[$scope.review_trade_index]._id}, 
                function(tradeBid) {
            tradeBid[0].submitted = 'false';
            tradeBid[0].$update();
            $scope.bid.bid_status = 'submitted';
            $scope.bid.$update();
            $location.path('requests');
        });
    };

    $scope.submitTradeBid = function() {
        var me = $filter('filter')($scope.bid.bidding_trades, {trade: $scope.getTradeString($scope.my_bid_trade)});
        if(me.length === 1) {
            me[0].submitted = 'true';
            $scope.bid.$update();
            $location.path('requests');
        } else {
            console.log('there are too many bidding trades here in submitTradeBid!!!');
        }
    };

    $scope.updateTablePlan = function() {
        $scope.bid_tasks = [];

        $scope.my_bid.task_list.forEach(function(task, index){
            if( task.trade === $scope.my_bid_trade){
                $scope.my_bid.bid.forEach(function(bid, ii) {
                    
                    if(bid.task_id === task._id) {
                        if(bid.plan_code === $scope.current_plan.item) {
                            bid.subtasks.forEach(function(subtask, si) {
                                task.subtasks.forEach(function(tsub, tsi) {
                                    if(subtask.task_id === tsub._id) {
                                        tsub.quantity = Number(subtask.quantity);
                                        tsub.bid_hours = Number(subtask.bid_hours);
                                        tsub.labor = Number(subtask.labor);
                                    }
                                });
                                if(!subtask.equipment) subtask.equipment = [];
                                subtask.equipment.forEach(function(eq, eidx) {
                                    task.subtasks[si].equipment.forEach(function(teq, teidx) {
                                        if(eq.equipment_id === teq._id) {
                                            teq.quantity = Number(eq.quantity);
                                            if(eq.price_per_order)
                                              teq.price_per_order = Number(eq.price_per_order);
                                            if(eq.delivery_price)
                                              teq.delivery_price = Number(eq.delivery_price);
                                        }
                                    });
                                });
                                if(!subtask.materials) subtask.materials = [];
                                subtask.materials.forEach(function(mq, midx) {
                                    task.subtasks[si].materials.forEach(function(tmq, tmidx) {
                                        if(mq.material_id === tmq._id && tmq._id) {
                                            tmq.quantity = Number(mq.quantity);
                                            if(mq.price_per_order)
                                              tmq.price_per_order = Number(mq.price_per_order);
                                            if(mq.delivery_price)
                                              tmq.delivery_price = Number(mq.delivery_price);
                                        }
                                    });
                                });
                            });
                        } else {
                            //this bid does not match the current plan but it matches the task.
                            //we need to see if there is a plan/bid for this task.
                            //if there is we need to leave it alone, if there is not
                            //then we should clear it out.
                            var bid_found = false;
                            for(var i=0; i<$scope.my_bid.bid.length; i=i+1){
                                if($scope.my_bid.bid[i].task_id === task._id &&
                                    $scope.my_bid.bid[i].plan_code === $scope.current_plan.item)
                                  bid_found = true;
                            }

                            if(!bid_found){
                                task.subtasks.forEach(function(sub) {
                                    sub.quantity = 0;
                                    sub.bid_hours = 0;
                                    sub.materials.forEach(function(mat){
                                        mat.quantity = 0;
                                        mat.materials_subtotal = 0;
                                        mat.materials_dev_subtotal = 0;
                                    });
                                    sub.equipment.forEach(function(eq) {
                                        eq.quantity = 0;
                                        eq.materials_subtotal = 0;
                                        eq.materials_dev_subtotal = 0;
                                    });
                                });
                            }
                        }
                    }
                });

                $scope.bid_tasks.push(task);
            }
        });

        $scope.applayCalculations($scope.bid_tasks);

        // data = $scope.bid_tasks;

        // $scope.bidTasksTableParams.reload();
    };

    $scope.applayCalculations = function(tasks) {
        taskTotalsService.getCalculations(tasks, $scope.company_factors);

        $scope.bid_total = tasks.bid_total;
        $scope.bid_general_liability = tasks.bid_general_liability;
        $scope.bid_total_labor = tasks.bid_total_labor;
        $scope.bid_total_materials = tasks.bid_total_materials;
        $scope.bid_materials_taxes = tasks.bid_materials_taxes;
        $scope.bid_materials_subtotal = tasks.bid_materials_subtotal;
        $scope.bid_total_equipment = tasks.bid_total_equipment;
        $scope.bid_equipment_subtotal = tasks.bid_equipment_subtotal;
        $scope.bid_equipment_taxes = tasks.bid_equipment_taxes;
        $scope.bid_direct_labor = tasks.bid_direct_labor;
        $scope.bid_mark_up = tasks.bid_mark_up;
        $scope.bid_workers_comp = tasks.bid_workers_comp;
        $scope.bid_payroll_taxes = tasks.bid_payroll_taxes;
        $scope.bid_overhead_and_profit = tasks.bid_overhead_and_profit;
        $scope.bid_total_hours_allowed = tasks.bid_total_hours_allowed;
        $scope.bid_direct_labor = tasks.bid_direct_labor;
        $scope.bid_workers_comp = tasks.bid_workers_comp;
        $scope.bid_payroll_taxes = tasks.bid_payroll_taxes;

        $scope.bid_menu.forEach(function(bid) {
            if($scope.current_plan.item === bid.item) {
                if(bid.item !== 'Cover') {
                    console.log('found the current item ' + bid.item);
                    bid.bid_total = tasks.bid_total;
                    bid.bid_direct_labor = tasks.bid_direct_labor;
                    bid.bid_total_labor = tasks.bid_total_labor;
                    bid.bid_total_materials = tasks.bid_total_materials;
                    bid.bid_total_equipment = tasks.bid_total_equipment;
                    bid.bid_general_liability = tasks.bid_general_liability;
                    bid.bid_workers_comp = tasks.bid_workers_comp;
                    bid.bid_payroll_taxes = tasks.bid_payroll_taxes;
                    bid.bid_overhead_and_profit = tasks.bid_overhead_and_profit;
                    bid.bid_total_hours_allowed = tasks.bid_total_hours_allowed;
                }
            }
        });
    };

    $scope.buildBidCoverPage = function() {
        //if(bid.item === 'Trade Rates') return;
        _.each($scope.bid_menu, function(bid) {
            if(!(bid.item === 'Specs' || bid.item === 'Total Materials' || bid.item === 'Trade Rates')) {
                $scope.current_plan = bid;
                $scope.updateTablePlan();
            }     
        });

        //$scope.current_plan = $scope.original_plan;
    };

    $scope.onSelect = function(item) {
        console.log('in the onSelect function ' + item.item);
        $scope.current_plan = item;
        if($scope.current_plan.item === 'Cover') {
            //$scope.original_plan = item;
            data = [];
            $scope.buildBidCoverPage();
            $scope.current_plan = item;
        } else if($scope.current_plan.item === 'Total Materials') {
            // $scope.materials = 
            //     bidRequestEditService.getMaterials($scope.my_bid.bid, $scope.my_bid.task_list);
            data = [];
        // } else if($scope.current_plan.item === 'Equipment') {
        //     data = [];
        } else if($scope.current_plan.item === 'Trade Rates') {
            data = [];
        } else if($scope.current_plan.item === 'Specs') {
            data = [];
        } else {
            $scope.updateTablePlan();
        }
    };

    $scope.setTaskEditId =  function(pid) {
        $scope.taskEditId = pid;
    };

    $scope.next =  function(item) {
        //pid -1 is the index of the current task so lets just start with the next task and iterate
        //$scope.update(item);
        var current_task_idx = item._id;
        for(; current_task_idx < $scope.my_bid.task_list.length; current_task_idx = current_task_idx + 1) {
            if($scope.my_bid.task_list[current_task_idx].trade === $scope.my_bid_trade) {
                $scope.taskEditId = $scope.my_bid.task_list[current_task_idx]._id;
                break;
            }
        }
    };

    $scope.update = function(item) {
        // we have an item to update.  look through the bidding trades to get the owner
        $scope.bid.bidding_trades.forEach(function(trade, index){
            if($scope.getTradeCode(trade.trade) === $scope.my_bid_trade) {
                //found the owner of the bid
                //see if this task is in his bid list
                var updated = false;
                trade.bid.forEach(function(bid, bi) {
                    if(bid.task_id === item._id){
                        if(bid.plan_code === $scope.current_plan.item) {
                            //found the task.  update with new info
                            updated = true;
                            bid.labor = item.labor;

                            bid.materials = [];
                            item.materials.forEach(function(tmat,tmi) {
                                bid.materials.push({
                                    material_id: tmat._id,
                                    quantity: tmat.quantity,
                                    price_per_order: tmat.price_per_order,
                                    delivery_price: tmat.delivery_price,
                                });
                            });

                            bid.equipment = [];
                            item.equipment.forEach(function(teqt, tei) {
                                bid.equipment.push({
                                    equipment_id: teqt._id,
                                    quantity: teqt.quantity,
                                    price_per_order: teqt.price_per_order,
                                    delivery_price: teqt.delivery_price
                                });
                            });

                            bid.subtasks = [];
                            item.subtasks.forEach(function(tsub, tsi) {
                                bid.subtasks.push({
                                    task_id: tsub._id,
                                    quantity: tsub.quantity,
                                    bid_hours: tsub.bid_hours,
                                    labor: tsub.labor
                                });
                            });
                        }
                    }
                });

                if(!updated) {
                    //the item to be updated was not found in the bidders list
                    trade.bid.push({
                        plan_code: $scope.current_plan.item,
                        task_id: item._id,
                        labor: item.labor,
                        materials: [],
                        equipment: [],
                        subtasks: []
                    });

                    if(item.materials.length) {
                        item.materials.forEach(function(mat, mi) {
                            trade.bid[trade.bid.length - 1].materials.push({
                                material_id: mat._id,
                                quantity: mat.quantity,
                                price_per_order: mat.price_per_order,
                                delivery_price: mat.delivery_price
                            });
                        });
                    }
                    if(item.equipment.length) {
                        item.equipment.forEach(function(mat, mi) {
                            trade.bid[trade.bid.length - 1].equipment.push({
                                equipment_id: mat._id,
                                quantity: mat.quantity,
                                price_per_order: mat.price_per_order,
                                delivery_price: mat.delivery_price
                            });
                        });
                    }
                    if(item.subtasks.length) {
                        item.subtasks.forEach(function(sub, si) {
                            trade.bid[trade.bid.length - 1].subtasks.push({
                                task_id: sub._id,
                                quantity: sub.quantity,
                                bid_hours: sub.bid_hours,
                                labor: sub.labor
                            });
                        });
                    }
                }

                $scope.bid.$update();
                
                $scope.updateTablePlan();
            }
        });
    };

    $scope.copyPlanData = function(from_plan, to_plan) {
        console.log('in copy function ' + $scope);
        to_plan.bid_direct_labor = from_plan.bid_direct_labor;
        to_plan.bid_general_liability = from_plan.bid_general_liability;
        to_plan.bid_overhead_and_profit = from_plan.bid_overhead_and_profit;
        to_plan.bid_payroll_taxes = from_plan.bid_payroll_taxes;
        to_plan.bid_total = from_plan.bid_total;
        to_plan.bid_total_equipment = from_plan.bid_total_equipment;
        to_plan.bid_total_hours_allowed = from_plan.bid_total_hours_allowed;
        to_plan.bid_total_labor = from_plan.bid_total_labor;
        to_plan.bid_total_materials = from_plan.bid_total_materials;
        to_plan.bid_workers_comp = from_plan.bid_workers_comp;

        $scope.bid.bidding_trades.forEach(function(trade_bid, idx) {
            if($scope.getTradeCode(trade_bid.trade) === $scope.my_bid_trade) {
                //found my trade bid list erase all entries for to_plan
                trade_bid.bid = $filter('filter')(trade_bid.bid, {plan_code: '!'+to_plan.item});

                var temp_list = [];
                //now add the plan entries
                trade_bid.bid.forEach(function(bid) {
                    if(bid.plan_code === from_plan.item) {
                        var temp_bid = {};
                        angular.copy(bid, temp_bid);
                        delete temp_bid._id;
                        var idx = temp_list.push(temp_bid) - 1;
                        temp_list[idx].plan_code = to_plan.item;
                    }
                });

                temp_list.forEach(function(add) {
                    trade_bid.bid.push(add);
                });
            }
        });

        $scope.bid.$update();
                
        $scope.updateTablePlan();
    };

    $scope.getHoursAllowed = function(bid_hours, current_net_pay, crew_rate) {
        return taskTotalsService.getHoursAllowed(bid_hours, current_net_pay, crew_rate);
    };

    $scope.getCurrentNetPay = function(bid_hours, crew_rate, quantity, piece_rate) {
        return taskTotalsService.getCurrentNetPay(bid_hours, crew_rate, quantity, piece_rate);
    };

    $scope.getQuantityAllowed = function(subtask, material) {
        if(subtask.unit === material.unit)
          return material.quantity ? material.quantity : subtask.quantity / material.piece_per_size;
        else
          return material.quantity;
    };

    $scope.getMaterialTotal = function(item, mat) {
        var value;
        if(mat.quantity)
            value = mat.quantity * mat.price_per_order;
        else
            value = $scope.getQuantityAllowed(item, mat) * mat.price_per_order;

        return value;
    };

    $scope.getDevSubtotal = function(item, mat) {
        var value = mat.quantity ? mat.quantity * mat.delivery_price : $scope.getQuantityAllowed(item, mat) * mat.delivery_price;

        return value;
    };

    $scope.getTradeString = function(trade) {
        return tradeCodeService.getName(trade);
    };

    $scope.getTradeCode = function(trade) {
        return tradeCodeService.getCode(trade);
    };

    $scope.updateRateDisplay = function() {
        console.log($scope.tradeItems);
        if($scope.tradeItems._id) {
            if($scope.tradeItems.crew_rate && $scope.tradeItems.equipment_costs &&
                $scope.tradeItems.hours_allowed && $scope.tradeItems.labor_costs &&
                $scope.tradeItems.liability && $scope.tradeItems.markup &&
                $scope.tradeItems.material_costs && $scope.tradeItems.trade_rates &&
                $scope.tradeItems.quantity) {
                $scope.tradeItems.$delete(function(success) {
                    toaster.pop('success', 'Trade Items Updated');
                    $scope.tradeItems = {
                        hours_allowed: true,
                        crew_rate: true,
                        trade_rates: true,
                        labor_costs: true,
                        liability: true,
                        markup: true,
                        material_costs: true,
                        equipment_costs: true,
                        quantity: true
                    }
                }, function(error) {
                    toaster.pop('error', 'Trade Items Error', error);
                });
            } else {
                $scope.tradeItems.$update(function(success) {
                    toaster.pop('success', 'Trade Items Updated');
                    $scope.tradeItems = success;
                }, function(error) {
                    toaster.pop('error', 'Trade Items Error', error);
                });
            }
        } else {
            var tradeItems = new TradeItems({
                'company_code': userService.getCompanyCode($scope.user.username),
                'trade_code': userService.getTradeCode($scope.user.username),
                'bid_id': $scope.bid._id,
                'crew_rate': $scope.tradeItems.crew_rate,
                'equipment_costs': $scope.tradeItems.equipment_costs,
                'hours_allowed': $scope.tradeItems.hours_allowed,
                'labor_costs': $scope.tradeItems.labor_costs,
                'liability': $scope.tradeItems.liability,
                'markup': $scope.tradeItems.markup,
                'material_costs': $scope.tradeItems.material_costs,
                'trade_rates': $scope.tradeItems.trade_rates,
                'quantity': $scope.tradeItems.quantity
            });

            tradeItems.$save(function(success) {
                toaster.pop('success', 'Trade Items Updated');
                $scope.tradeItems = success;
            }, function(error) {
                toaster.pop('error', 'Trade Items Error', error);
            });
        }
    };
  }
]);


// WEBPACK FOOTER //
// ./packages/custom/bids/public/controllers/bidrequestreview.js